// extracted by mini-css-extract-plugin
export default {"body":"styles_body__itX5W","groupButton":"styles_groupButton__ri7uV","currentGroupIon":"styles_currentGroupIon__NmR66"};